Alpine.store('cart', {
    oldItems: [],
    items: [],
    total: 0,
    mainEvent: {},
    debounce: null,
    showUpsell: true,
    prepaidDone: false,

    init () {
        window.addEventListener('cart::load', ({detail: cart}) => {
            if (cart) {
                this.items = cart;
            }

            this.update(false);
        });

        window.addEventListener('cart::mainEvent', ({detail: mainEvent}) => {
            this.mainEvent = mainEvent[0];
            this.oldItems = this.items;
            this.items = [];
        });

        window.addEventListener('cart::setTotal', ({ detail }) => {
            if (! detail?.total) {
                return;
            }

            this.total = detail.total;
        });

        window.addEventListener('cart::prepaid-done', ({ detail: prepaidDone }) => {
            this.prepaidDone = _.get(prepaidDone, 0);
        });
    },

    remove(index) {
        if( this.items[index].quantity === 1 ) {
            this.items.splice(index, 1);
        } else {
            this.items[index].quantity = Math.max(this.items[index].quantity-1, 0);
        }

        this.update();
    },

    add(index) {
        const cartPackage = this.items[index];

        if( cartPackage.is_digital ) {
            return;
        }

        this.items[index].quantity += 1;
        this.update();

        return this.items[index];
    },

    addPackage(cartData, update=false) {
        const packageIndex = _.get(cartData, 'index');

        if(packageIndex !== null && update ) {
            cartData.quantity = this.items[packageIndex].quantity;
            this.items[packageIndex] = cartData;

            this.update();

            return;
        }

        this.items.push({
            ...cartData,
            index: this.items.length
        });

        this.update();
    },

    showWatermark() {
        return _.get(this.mainEvent.settings ?? {}, 'watermarking_on_customer_side', false);
    },

    quantity(index) {
        return _.get(this.items[index], 'quantity', 0);
    },

    hasRequirementImages(index) {
        const requirements = _.get(this.items[index], 'package.template.requirement_images', {});

        return Object.values(requirements).length > 0;
    },

    hasNotDigitalItems() {
        return this.items.filter(item => !item.is_digital).length > 0;
    },

    update(changeOld=true) {
        clearTimeout(this.debounce);

        this.debounce = setTimeout(() => {
            Livewire.dispatch('cart::update', { cart: this.items, total: this.total});
        }, 500);

        if(changeOld) {
            this.oldItems = Object.assign([], this.items);
        }
    },

    getImages(index, digitalType=null) {
        const cartItems = _.get(this, 'items', {});
        const item = _.get(cartItems, index, {});

        let images = _.values(
            _.get(item, 'images')
        );

        images = images.reduce(function(images, cartImages){
            return [...images, ..._.values(cartImages)];
        }, []);

        if(digitalType && item.is_digital === digitalType && images.length > 6) {
            return [...images.splice(0, 5), `... and ${images.length} more`];
        }

        return images;
    }
});
